import {ExpandMore} from "@mui/icons-material";
import {Accordion, AccordionDetails, AccordionSummary, Grid, TextField} from "@mui/material";
import * as React from "react";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import dayjs from "dayjs";
import {calculateDateDifference} from "../../../../component/utils/Utils";

const RentalAgreement = (props: any) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'theftMisappropriate'});
    const [isExpanded, setIsExpanded] = useState(false);
    const customerAndRADetails = props.customerAndRADetails;

    return (
        <Accordion defaultExpanded onChange={(_e, expanded) => {
            setIsExpanded(expanded);
        }}>
            <AccordionSummary expandIcon={<ExpandMore/>}>
                <Grid item md={6} xs={6}>
                    {t("customerRADetails.rentalAgreement")}
                </Grid>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container columnSpacing={3} rowSpacing={1}>

                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="raNumber"
                            value={customerAndRADetails?.raNumber}
                            label={t("rentalAgreement.raNumber")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="raSectional"
                            value={customerAndRADetails?.dmsCode?.code}
                            label={t("rentalAgreement.raSectional")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            value={customerAndRADetails?.raDate ? dayjs(customerAndRADetails.raDate).format("L") : ""}
                            disabled={true}
                            id="raDate"
                            type="text"
                            label={t("rentalAgreement.raDate")}
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="renewalsAndSubstitutions"
                            value={customerAndRADetails?.renewalsSubstitution}
                            label={t("rentalAgreement.renewalsAndSubstitutions")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="rentalType"
                            value={customerAndRADetails?.financialInfo?.segmentDescription}
                            label={t("rentalAgreement.rentalType")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="overdueDays"
                            value={
                                customerAndRADetails?.raState?.code === "EXPIRED" && customerAndRADetails?.checkIn?.expectedCheckInDate
                                    ? calculateDateDifference(customerAndRADetails?.checkIn?.expectedCheckInDate)
                                    : ""
                            }
                            label={t("rentalAgreement.overdueDays")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="recoverCompany"
                            value={customerAndRADetails?.recoverCompany}
                            label={t("rentalAgreement.recoverCompany")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="STPlus"
                            value={customerAndRADetails?.STPlus}
                            label={t("rentalAgreement.STPlus")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="pickUpLocation"
                            value={customerAndRADetails?.bookingDetail ? customerAndRADetails.bookingDetail.pickUpLocation.description : ""}
                            label={t("rentalAgreement.pickUpLocation")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>

                        <TextField
                            label={t("rentalAgreement.pickUpDate")}
                            value={customerAndRADetails?.bookingDetail?.pickupDate ? dayjs(customerAndRADetails.bookingDetail.pickupDate).format("L") : ""}
                            fullWidth
                            disabled={true}
                            id="pickUpDate"
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />

                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="dropOffLocation"
                            value={customerAndRADetails?.bookingDetail?.dropOffLocation?.description}
                            label={t("rentalAgreement.dropOffLocation")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>

                        <TextField
                            fullWidth
                            label={t("rentalAgreement.dropOffDate")}
                            value={customerAndRADetails?.bookingDetail?.dropoffDate ? dayjs(customerAndRADetails.bookingDetail.dropoffDate).format("L") : ""}
                            disabled={true}
                            id="dropOffDate"
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />

                    </Grid>

                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="ccEncryptedNumber"
                            value={customerAndRADetails?.sixDigitCreditCard}
                            label={t("driversDetails.ccEncryptedNumber")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="previousRentals"
                            value={customerAndRADetails?.previousRentals}
                            label={t("driversDetails.previousRentals")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default RentalAgreement;